import styled from "styled-components";

const DateFilterWrapper = styled.div`
  .react-datepicker {
    border: 1px solid var(--grey_10);
    border-radius: 0.8rem;
    overflow: hidden;
  }

  .react-datepicker__header {
    background-color: #ffffff;
    border-bottom: 1px solid (var--grey_10);
    padding-top: 1.4rem;
  }

  .react-datepicker__day-name,
  .react-datepicker__day,
  .react-datepicker__time-name {
    width: 3.2rem;
    line-height: 3.2rem;
  }

  .react-datepicker__day-name,
  .react-datepicker__day,
  .react-datepicker__time-name {
    color: var(--grey_1);
    font-size: 1.5em;
  }

  .react-datepicker__day--selected,
  .react-datepicker__day--in-selecting-range,
  .react-datepicker__day--in-range,
  .react-datepicker__month-text--selected,
  .react-datepicker__month-text--in-selecting-range,
  .react-datepicker__month-text--in-range,
  .react-datepicker__quarter-text--selected,
  .react-datepicker__quarter-text--in-selecting-range,
  .react-datepicker__quarter-text--in-range,
  .react-datepicker__year-text--selected,
  .react-datepicker__year-text--in-selecting-range,
  .react-datepicker__year-text--in-range {
    background-color: var(--primary);
    color: #ffffff;
  }

  .react-datepicker__current-month,
  .react-datepicker-time__header,
  .react-datepicker-year-header {
    color: var(--grey_1);
    font-size: 1.5em;
  }

  .react-datepicker__navigation {
    top: 10px;
  }
`;

export default DateFilterWrapper;
